<div class="div-container" fxLayout="column" fxFlexFill>
  <div class="div-header" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center">
    <img alt="img" src="assets/icons/language_icon.png" height="24" width="32" />
    <span class="span-title textLarge medium">{{'select_your_language' | transloco}}</span>
  </div>
  <div fxLayoutAlign="center start">
    <span fxLayout="column" fxLayoutGap="30px" style="padding-top: 20px;padding-bottom: 20px;">

      <mat-radio-group aria-label="Select an option" fxLayout="column" fxLayoutGap="10px" [(ngModel)]="selectedOption">
        <div fxFlexFill class="div-radiobutton" ngClass.xs="div-radiobutton xs" *ngFor="let language of languages">
          <mat-radio-button color="primary" class="textLarge regular" ngClass.xs="textsmaller regular" [value]="language.culture">{{language.name}}
            {{ language.name==='English' ? '( By Default )' :''}}
          </mat-radio-button>
        </div>
      </mat-radio-group>

      <button *ngIf="!onStartUp" fxFlexAlign="center" mat-flat-button color="primary" class="button-chkavailable"
        (click)="onApply()">
        {{'apply' | transloco}}
      </button>
      <button *ngIf="onStartUp" fxFlexAlign="center" mat-flat-button color="primary" class="button-chkavailable"
         (click)="onContinue()">
         {{'continue' | transloco}}
      </button>
    </span>
  </div>
</div>
<app-loader *ngIf="show"></app-loader>
